// @dynamic-i18n-keys
// Dynamic t() at line 87 (value === '0' ? original : preset):
//   deviationSubmit.form.displayResolution.option.label.original
//   deviationSubmit.form.displayResolution.option.label.preset
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import CommonDisplayOptionsField from '../../../common/fields/DisplayOptionsField';
import { OriginalDeviationFieldName } from '../../types';

interface Props {
  deviation?: PapiDeviation;
}

const DisplayOptionsField: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();

  return (
    <CommonDisplayOptionsField
      deviation={deviation}
      displayResolutionFieldName={OriginalDeviationFieldName.DISPLAY_RESOLUTION}
      addWatermarkFieldName={OriginalDeviationFieldName.ADD_WATERMARK}
      label={t('originalDeviationPopup.form.displayResolution.label')}
    />
  );
};
DisplayOptionsField.displayName = 'DisplayOptionsField';

export default DisplayOptionsField;
